<div class="modal-with-one-select-container">
  <div class="header-container">
    <h2>{{ 'medicalHistory.medicalNewRecordModal.add' | translate }} {{ 'medicalHistory.medicalNewRecordModal.' + data.key | translate }}</h2>
    <p>
      {{ 'medicalHistory.medicalNewRecordModal.insert_here' | translate }} {{ 'medicalHistory.medicalNewRecordModal.' + data.key | translate }}
      {{ 'medicalHistory.medicalNewRecordModal.and_date' | translate }}
    </p>
  </div>

  <form [formGroup]="formModal">
    @if (data.key === 'pathology' || data.key === 'surgical') {
      <div class="pathology">
        <div nz-row>
          <app-aria-autocomplete-field
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            nzXl="12"
            [label]="'medicalHistory.medicalNewRecordModal.' + data.key | translate | titlecase"
            [placeholder]="'medicalHistory.medicalNewRecordModal.choose' | translate"
            [options]="toAriaOptions(modalOptions)"
            [required]="true"
            formControlName="option"
          ></app-aria-autocomplete-field>
        </div>
        <div>
          <div class="first-container">
            <div class="genere">
              <p>{{ 'medicalHistory.medicalNewRecordModal.genere' | translate }}</p>
              <span>{{ details.gender }}</span>
            </div>
            <div>
              <p>{{ 'medicalHistory.medicalNewRecordModal.sistema' | translate }}</p>
              <span>{{ details.apparatus }}</span>
            </div>
          </div>
          <div class="second-container">
            <div class="organo-interno">
              <p>{{ 'medicalHistory.medicalNewRecordModal.internal_organ' | translate }}</p>
              <span>{{ details.organ }}</span>
            </div>
            <div>
              <p>{{ 'medicalHistory.medicalNewRecordModal.body_part' | translate }}</p>
              <span>{{ details.bodyPart }}</span>
            </div>
          </div>
        </div>
        @if (data.key === 'pathology') {
          <div style="margin-top: 15px; margin-bottom: 15px">
            <label class="checkbox" nz-checkbox formControlName="underTherapy" aria-label="In terapia per questa patologia">{{ 'medicalHistory.medicalNewRecordModal.under_therapy' | translate }}</label>
          </div>
        }
      </div>
    }
    @if (data.key === 'allergen') {
      <div class="allergen">
        <div nz-row class="drug-margin">
          <app-aria-autocomplete-field
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            nzXl="12"
            [label]="'medicalHistory.medicalNewRecordModal.' + data.key | translate | titlecase"
            [placeholder]="'medicalHistory.medicalNewRecordModal.choose' | translate"
            [options]="toAriaOptions(modalOptions)"
            [required]="true"
            formControlName="option"
          ></app-aria-autocomplete-field>
        </div>
        <div nz-row class="drug-margin">
          <app-aria-autocomplete-field
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            nzXl="12"
            [label]="'medicalHistory.medicalNewRecordModal.specificAllergen' | translate"
            [placeholder]="'medicalHistory.medicalNewRecordModal.choose' | translate"
            [options]="toAriaOptions(specificAllergenOptions)"
            formControlName="specificAllergen"
          ></app-aria-autocomplete-field>
        </div>
      </div>
    }
    @if (data.key === 'vaccination') {
      <div class="vaccination">
        <div nz-row class="drug-margin">
          <app-aria-autocomplete-field
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            nzXl="12"
            [label]="'medicalHistory.medicalNewRecordModal.vaccinazione' | translate"
            [placeholder]="'medicalHistory.medicalNewRecordModal.choose' | translate"
            [options]="toAriaOptions(modalOptions)"
            [required]="true"
            formControlName="option"
          ></app-aria-autocomplete-field>
        </div>
        @if (formModal.get('date')) {
          <app-aria-date-picker-field
            class="drug-margin date-vaccination"
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            nzXl="12"
            [label]="'medicalHistory.medicalNewRecordModal.date' | translate"
            [minDate]="leaveYears(todayDate)"
            [maxDate]="todayDate"
            placeholder=""
            [required]="true"
            mode="single"
            mobileDrawer="auto"
            formControlName="date"
          ></app-aria-date-picker-field>
        }
        <div style="margin-top: 20px" class="drug-margin">
          <label class="checkbox" nz-checkbox formControlName="revaccination" aria-label="Richiesta dose booster di richiamo"> {{ 'medicalHistory.medicalNewRecordModal.booster' | translate }} </label>
        </div>
        <app-aria-date-picker-field
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="12"
          nzLg="12"
          nzXl="12"
          [label]="'medicalHistory.medicalNewRecordModal.booster_date' | translate"
          [minDate]="addDays(todayDate)"
          [maxDate]="addYears(todayDate)"
          placeholder=""
          mode="single"
          mobileDrawer="auto"
          formControlName="revaccinationDate"
        ></app-aria-date-picker-field>
      </div>
    }
    @if (data.key === 'drug') {
      <div class="drug">
        <div nz-row class="drug-margin">
          <app-aria-autocomplete-field
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            nzXl="12"
            [label]="'medicalHistory.medicalNewRecordModal.active_ingredient' | translate"
            [placeholder]="'medicalHistory.medicalNewRecordModal.choose' | translate"
            [options]="toAriaOptions(modalOptions)"
            [required]="true"
            formControlName="option"
          ></app-aria-autocomplete-field>
        </div>
        <div nz-row class="drug-margin">
          <app-aria-autocomplete-field
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            nzXl="12"
            [label]="'medicalHistory.medicalNewRecordModal.size' | translate"
            [placeholder]="'medicalHistory.medicalNewRecordModal.choose' | translate"
            [options]="toAriaOptions(drugFormats)"
            formControlName="format"
          ></app-aria-autocomplete-field>
        </div>
        <div class="drug-margin">
          <div>{{ 'medicalHistory.medicalNewRecordModal.active_ingredient' | translate }}:</div>
          @if (selectedDrugName) {
            <div style="margin-top: 15px">
              <span>{{ selectedDrugName }}</span>
            </div>
          }
          @if (!selectedDrugName) {
            <div style="margin-top: 15px">
              <span>-</span>
            </div>
          }
        </div>
        <div nz-row style="align-items: end" class="drug-margin">
          <ds-input-text
            class="input-drug"
            [label]="'medicalHistory.medicalNewRecordModal.dosage' | translate"
            [control]="formModal.get('posology')"
           [placeholder]="'medicalHistory.medicalNewRecordModal.write' | translate"
          ></ds-input-text>
          <app-aria-autocomplete-field
            class="unit"
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            nzXl="8"
            [label]="'medicalHistory.medicalNewRecordModal.select_unit' | translate"
            [placeholder]="'medicalHistory.medicalNewRecordModal.select_unit' | translate"
            [options]="[
              { label: 'Unità', value: 'UNITA' },
              { label: 'ml', value: 'ML' },
              { label: 'Grammi', value: 'GRAMMI' },
              { label: 'Numero di applicazioni', value: 'Applicazioni' }
            ]"
            formControlName="unit"
          ></app-aria-autocomplete-field>
        </div>
        <div nz-row style="align-items: flex-start;" class="drug-margin container-select-drugs">
          <app-aria-autocomplete-field
            class="posologyFrequence"
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            nzXl="11"
            [label]="'medicalHistory.medicalNewRecordModal.frequency' | translate"
            [placeholder]="'medicalHistory.medicalNewRecordModal.select_unit' | translate"
            [options]="[
              {
                label: ('medicalHistory.medicalNewRecordModal.every_x_hours' | translate),
                value: ('medicalHistory.medicalNewRecordModal.times' | translate)
              }
            ]"
            formControlName="posologyFrequence"
          ></app-aria-autocomplete-field>
         <app-aria-autocomplete-field
            class="dose"
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="12"
            nzLg="12"
            nzXl="13"
            label=""
            placeholder="1"
            [options]="doseOptions"
            formControlName="dose"
          ></app-aria-autocomplete-field>
        </div>
      </div>
    }
    @if (data.key !== 'drug' && data.key !== 'vaccination') {
      <app-aria-date-picker-field
        nz-col
        nzXs="24"
        nzSm="24"
        nzMd="12"
        nzLg="12"
        nzXl="12"
        [label]="'medicalHistory.medicalNewRecordModal.date' | translate"
        [minDate]="leaveYears(todayDate)"
        [maxDate]="todayDate"
        placeholder=""
        [required]="true"
        mode="single"
        mobileDrawer="auto"
        formControlName="date"
    ></app-aria-date-picker-field>
    }
    @if (data.key !== 'vaccination') {
      <div>
        <p style="color: var(--text)">{{ 'medicalHistory.medicalNewRecordModal.additional_notes' | translate }}</p>
        <ds-input-text [type]="'textarea'" [control]="formModal.get('notes')" [placeholder]="'medicalHistory.medicalNewRecordModal.describe_details' | translate"></ds-input-text>
      </div>
    }
    <div class="button-container">
      <ds-button class="button-exit" [text]="'buttons.exit' | translate" [styleType]="'empty-main'" [width]="'small'" (click)="close()"></ds-button>
      <ds-button class="button-register" [text]="'buttons.regist' | translate" [width]="'small'" (click)="save()" [isDisabled]="formModal.invalid"></ds-button>
    </div>
  </form>
</div>
